export const FirebaseConfig = {
	"projectId": "toto-d002d",
	"appId": "1:875441403827:web:389515c78c499a06e57dc6",
	"databaseURL": "https://toto-d002d-default-rtdb.asia-southeast1.firebasedatabase.app",
	"storageBucket": "toto-d002d.firebasestorage.app",
	"apiKey": "AIzaSyDtJ5F7flsKUgOvKAtaE-YRxEeOXF771qw",
	"authDomain": "toto-d002d.firebaseapp.com",
	"messagingSenderId": "875441403827",
	"measurementId": "G-PDEH1ZMFB7",
	"projectNumber": "875441403827",
	"version": "2"
};